import React from 'react';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import NotifyIcon from '../../assets/images/notifiyIcon.svg';
import { getHolidaysThisMonth } from '../../holidays';

import WorkIcon from '../../assets/images/workIcon.svg';
function ViewMore({ data }: { data: any }) {
  const holiday = getHolidaysThisMonth();
  return (
    <div className="grid  md:grid-cols-2 grid-cols-1 lg:grid-cols-4 gap-4">
      <div className="bg-white flex justify-between items-center py-2 px-6 rounded-md gap-6">
        <div className="flex flex-col ">
          <h1 className="text-5xl text-[#939393]">
            {data?.totalLeaveBalance}{' '}
          </h1>
          <p className="text-[10px]">Remaining Leaves </p>
        </div>
        <div className="pt-4">
          <div className="w-full flex justify-center items-center">
            <FaRegCalendarAlt color="#6E3EF5" size={18} />
          </div>
          <p className="text-[10px] mt-2">
            {data?.leaveBalance?.General} General{' '}
          </p>
          <p className="text-[10px]">
            {data?.leaveBalance?.Optional} Optional{' '}
          </p>

          <Link
            to="/dashboard/leaveManagement"
            className="text-[10px] m-0 p-0 text-[#6E3EF5] text-center w-full"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="bg-white flex justify-between items-center py-2 px-6 rounded-md gap-6">
        <div className="flex flex-col ">
          <h1 className="text-5xl text-[#939393] ">
            {data?.totalHoursWorkedThisMonth}{' '}
          </h1>
          <p className="text-[10px] ">Working Hours this month </p>
        </div>
        <div className="pt-4">
          <div className="w-full flex justify-center items-center">
            <img src={WorkIcon} className="h-6 w-6" />
          </div>
          <p className="text-[10px] mt-2">
            {data?.totalHoursComparedToLastMonth < 0
              ? `${Math.abs(
                  data?.totalHoursComparedToLastMonth
                )} Hours Less than the previous`
              : `${data?.totalHoursComparedToLastMonth} Hours More than the previous`}
          </p>
        </div>
      </div>
      <div className="bg-white flex justify-between items-center py-2 px-6 rounded-md gap-6">
        <div className="flex flex-col ">
          <h1 className="text-5xl text-[#939393] ">
            {holiday?.totalHolidays}{' '}
          </h1>
          <p className="text-[10px] ">Holidays this Month </p>
        </div>
        <div className="pt-4">
          <div className="w-full flex justify-center items-center">
            <FaRegCalendarAlt color="#6E3EF5" size={18} />
          </div>
          {holiday?.holidays?.map((holiday, idx) => {
            const day = holiday.date.getDate().toString().padStart(2, '0');
            return (
              <p key={idx} className="text-xs font-inter">
                {day} {holiday.info}
              </p>
            );
          })}
          <Link
            to="/dashboard/leavesAndOccasions/occasions"
            className="text-[10px] m-0 p-0 text-[#6E3EF5] text-center w-full"
          >
            View More
          </Link>
        </div>
      </div>
      <div className="bg-white flex justify-between items-center py-2 px-6 rounded-md gap-6">
        <div className="flex flex-col ">
          <h1 className="text-5xl text-[#939393] ">{data?.totalRequests} </h1>
          <p className="text-[10px] w-3/4">Notifications Announcements </p>
        </div>
        <div className="pt-4">
          <div className="w-full flex justify-center items-center">
            <img src={NotifyIcon} className="h-8 w-8" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewMore;
